/* eslint-disable @typescript-eslint/no-explicit-any */
const ResizeObserverDirective = (
  el: any,
  { expression }: any,
  { evaluateLater, cleanup }: any
) => {
  const evaluate = evaluateLater(expression);

  const obs = new ResizeObserver(() => evaluate());
  obs.observe(el);

  cleanup(() => obs.disconnect());
};

export default ResizeObserverDirective;
